module.exports = __webpack_public_path__ + "static/images/division-top-bg.ec7d513.png";